function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LoadingButton from '../LoadingButton';
var useStyles = makeStyles({
  closeButton: {
    position: 'absolute',
    top: 14,
    right: 14
  },
  subtitle: {
    marginBottom: 20
  }
}, {
  classNamePrefix: 'ConfirmDialog'
});

function getConfirmButtonText(confirmButtonText, type) {
  return confirmButtonText !== null ? confirmButtonText : type === 'alert' ? 'Ok' : 'Yes';
}

var ConfirmDialog = function ConfirmDialog(props) {
  var type = props.type,
      className = props.className,
      children = props.children,
      open = props.open,
      titleText = props.titleText,
      TitleProps = props.TitleProps,
      subtitleText = props.subtitleText,
      SubtitleProps = props.SubtitleProps,
      descriptionText = props.descriptionText,
      DescriptionProps = props.DescriptionProps,
      confirmButtonText = props.confirmButtonText,
      ConfirmButtonProps = props.ConfirmButtonProps,
      cancelButtonText = props.cancelButtonText,
      CancelButtonProps = props.CancelButtonProps,
      onClose = props.onClose,
      onConfirm = props.onConfirm,
      other = _objectWithoutProperties(props, ["type", "className", "children", "open", "titleText", "TitleProps", "subtitleText", "SubtitleProps", "descriptionText", "DescriptionProps", "confirmButtonText", "ConfirmButtonProps", "cancelButtonText", "CancelButtonProps", "onClose", "onConfirm"]);

  var classes = useStyles();
  return React.createElement(Dialog, _extends({
    className: className,
    open: open,
    onClose: onClose,
    "aria-labelledby": "confirmation-dialog-title",
    "aria-describedby": "confirmation-dialog-description"
  }, other), React.createElement(DialogTitle, {
    disableTypography: true
  }, titleText && React.createElement(Typography, _extends({
    id: "confirmation-dialog-title",
    component: "h2",
    variant: "h4"
  }, TitleProps), titleText), React.createElement(IconButton, {
    className: classes.closeButton,
    onClick: onClose,
    "aria-label": "close"
  }, React.createElement(CloseIcon, null))), React.createElement(DialogContent, {
    id: "confirmation-dialog-description"
  }, !children && subtitleText && React.createElement(DialogContentText, _extends({
    className: classes.subtitle,
    component: "h3",
    variant: "h5"
  }, SubtitleProps), subtitleText), !children && descriptionText && React.createElement(DialogContentText, DescriptionProps, descriptionText), children), React.createElement(DialogActions, null, type !== 'alert' && React.createElement(LoadingButton, _extends({
    variant: "text",
    onClick: onClose,
    "data-qa-selector": "confirmation-dialog-cancel-button"
  }, CancelButtonProps), cancelButtonText), React.createElement(LoadingButton, _extends({
    variant: "text",
    onClick: onConfirm,
    "data-qa-selector": "confirmation-dialog-confirm-button",
    autoFocus: true
  }, ConfirmButtonProps), getConfirmButtonText(confirmButtonText, type))));
};

ConfirmDialog.propTypes = {
  type: PropTypes.oneOf(['confirm', 'alert']),
  className: PropTypes.string,
  children: PropTypes.node,
  open: PropTypes.bool,
  titleText: PropTypes.string,
  TitleProps: PropTypes.object,
  subtitleText: PropTypes.string,
  descriptionText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  DescriptionProps: PropTypes.object,
  confirmButtonText: PropTypes.string,
  ConfirmButtonProps: PropTypes.object,
  cancelButtonText: PropTypes.string,
  CancelButtonProps: PropTypes.object,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};
ConfirmDialog.defaultProps = {
  type: 'confirm',
  className: '',
  children: null,
  open: false,
  titleText: '',
  TitleProps: {},
  subtitleText: '',
  SubtitleProps: {},
  descriptionText: '',
  DescriptionProps: {},
  confirmButtonText: null,
  ConfirmButtonProps: {},
  cancelButtonText: 'No',
  CancelButtonProps: {},
  onClose: function onClose() {},
  onConfirm: function onConfirm() {}
};
export default ConfirmDialog;